import React from 'react';
import moment from 'moment';
import renderHtml from 'react-render-html';

const EventEntry = ({ schedule }) => {
  const { title, startDate, marketingLink, isInternalLink } = schedule;
  const formattedMarketingLink = `${marketingLink}?date=${moment(
    startDate
  ).format('YYYY-MM-DD')}`;

  return (
    <div className="event-entry">
      {marketingLink ? (
        <a
          href={formattedMarketingLink}
          target={!isInternalLink ? '_blank' : '_self'}
          rel="noopener noreferrer"
          className="event-cta-link"
        >
          {renderHtml(title)}
        </a>
      ) : (
        <p className="event-title">{renderHtml(title)}</p>
      )}
    </div>
  );
};

export default EventEntry;
